import React from "react";
import {
  Logo,
  TitleSection,
  InfoSection,
  LogoSection,
  Factoring,
  Invoitix,
  ButtonDiv,
  FormContainer,
  FormWrapperInner,
  InputContainer,
  VATbutton,
  SelectContainer,
  selectStyles,
} from "./Styles";
import invoitixLogo from "../../../src/images/Invoitix.png";
import logo from "../../../src/images/logo.svg";
import Container from "../../components/UI/Container";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { useState, useRef } from "react";
import Select from "react-select";
import allCountries from "../../data/allCountries.json";

// Supported country codes for Invoitix
const supportedCountryCodes = [
  "POL",
  "LTU",
  "LVA",
  "EST",
  "ROU",
  "CZE",
  "SVK",
  "BGR",
  "SVN",
  "ESP",
  "SRB",
];

// Filter countries to only include supported ones
const countries = allCountries.countries
  .map((group) => ({
    ...group,
    options: group.options.filter((country) =>
      supportedCountryCodes.includes(country.shorthand)
    ),
  }))
  .filter((group) => group.options.length > 0); // Remove empty groups

const FactoringPage = () => {
  const [country, setCountry] = useState("");
  const [companyName, setCompanyName] = useState();
  const [vatNumber, setVatNumber] = useState();
  const [contactPerson, setContactPerson] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState(0);
  const [message, setMessage] = useState("");
  const [salesEmail, setSalesEmail] = useState("");

  // Function to get sales email based on country
  const getSalesEmail = (countryCode) => {
    const countryEmailMap = {
      POL: "pl_sales@invoitix.com", // Poland
      LTU: "pl_sales@invoitix.com", // Lithuania
      LVA: "pl_sales@invoitix.com", // Latvia
      EST: "pl_sales@invoitix.com", // Estonia
      ROU: "ro_sales@invoitix.com", // Romania
      CZE: "cz_sales@invoitix.com", // Czech Republic
      SVK: "cz_sales@invoitix.com", // Slovakia
      BGR: "bg_sales@invoitix.com", // Bulgaria
      SVN: "rs_sales@invoitix.com", // Slovenia
      ESP: "es_sales@invoitix.com", // Spain
      SRB: "rs_sales@invoitix.com", // Serbia
    };

    return countryEmailMap[countryCode] || "sales@invoitix.com";
  };

  const reRef = useRef(<ReCAPTCHA />);

  const postAdminData = async (e) => {
    e.preventDefault();
    const token = await reRef.current.executeAsync();
    reRef.current.reset();
    axios
      .post(
        "https://api.transconnector.eu/invoitixdata",
        {
          data: {
            country: country,
            company: companyName,
            contactPerson: contactPerson,
            vatNumber: vatNumber,
            phone: phone,
            email: email,
            message: message,
            token,
          },
        },
        {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          window.location.href = "https://www.invoitix.com";
        }
      });
  };

  const err = () => {
    alert("please select country before submitting");
  };
  return (
    <Factoring>
      <Container gutter="large">
        <LogoSection>
          <Logo src={logo} alt="transconnector Logo" />
          <Logo src={invoitixLogo} alt="Invoitix Logo" />
        </LogoSection>
      </Container>
      <Container gutter="medium">
        <TitleSection>
          <h1>
            TransConnector in cooperation with <br />
            <Invoitix>INVOITIX FACTORING SOLUTIONS</Invoitix>
          </h1>
        </TitleSection>
      </Container>
      <Container gutter="medium">
        <h2>
          Are you waiting 30, 45, 60 days to get paid for transport services
          done? Wait no longer, Invoitix offers solutions for payment in 48
          hours!
        </h2>
        <InfoSection>
          <ul>
            <li>
              We will pay 100% of the invoice amount minus our fee. We are
              transparent, no hidden fees and charges.
            </li>
            <li>
              Easy online tool to manage your invoices. Upload transportation
              documentation to our platform and let us do the rest!
            </li>
            <li>
              Save on administration costs. We communicate with your customer
              and manage payment from invoice creation to its collection.
            </li>
            <li>
              Check your clients before accepting the load! Invoitix 24/7 access
              to credit info of 20 000+ customers.
            </li>
          </ul>
        </InfoSection>
      </Container>

      <br />

      <Container gutter="medium">
        <h2>
          Financial solutions for companies working with subcontracted
          transporters
        </h2>
        <InfoSection>
          <p>
            Invoitix has financial solutions for freight forwarders, dispatching
            agencies, manufacturing companies, and others who rely on
            subcontracted transporters. We provide fast and reliable financing
            to improve your cash flow, strengthen your negotiation position, and
            build stronger business relationships.
          </p>
          <p>
            For more information visit{" "}
            <a
              href="https://www.invoitix.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.invoitix.com
            </a>
          </p>
        </InfoSection>
      </Container>

      <FormContainer style={{ width: "100%" }}>
        <FormWrapperInner style={{ maxWidth: "650px" }}>
          <form onSubmit={postAdminData}>
            <InputContainer>
              <h3>Contact Invoitix for instant payment solutions:</h3>
            </InputContainer>
            <InputContainer>
              <label htmlFor="country">Country: </label>
              <SelectContainer>
                <Select
                  name="country"
                  options={countries}
                  styles={selectStyles}
                  required
                  onSubmit={country === "" ? err : ""}
                  onChange={(choice) => {
                    setCountry(choice.shorthand);
                    setSalesEmail(getSalesEmail(choice.shorthand));
                  }}
                />
              </SelectContainer>
            </InputContainer>
            <br />
            <InputContainer>
              <label htmlFor="company_name">Company Name: </label>
              <input
                id="company_name"
                type="text"
                value={companyName}
                required
                placeholder="Company Name"
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
              />
            </InputContainer>
            <br />
            <InputContainer>
              <label htmlFor="company_vat">Company VAT Number: </label>
              <input
                id="company_vat"
                type="text"
                value={vatNumber}
                required
                placeholder="VAT"
                onChange={(e) => {
                  setVatNumber(e.target.value);
                }}
              />
            </InputContainer>
            <br />

            <InputContainer>
              <label htmlFor="contact">Name of Contact Person: </label>
              <input
                id="contact"
                type="text"
                value={contactPerson}
                required
                placeholder="Contact Person"
                onChange={(e) => setContactPerson(e.target.value)}
              />
            </InputContainer>
            <br />

            <InputContainer>
              <label htmlFor="phone">Phone Number: </label>
              <input
                id="phone"
                type="number"
                value={phone}
                required
                placeholder="Phone number"
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
              />
            </InputContainer>
            <br />

            <InputContainer>
              <label htmlFor="email">E-mail: </label>
              <input
                id="email"
                type="email"
                value={email}
                required
                placeholder="email@email.com"
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputContainer>
            {/* optional message */}
            <br />
            <InputContainer>
              <label htmlFor="message">Message (optional): </label>
              <textarea
                id="message"
                value={message}
                placeholder="Your message"
                onChange={(e) => setMessage(e.target.value)}
              />
            </InputContainer>
            <ButtonDiv>
              <ReCAPTCHA
                sitekey="6LenyGkiAAAAAHIokUL5B2k6qb3y4fGmPitExsFg"
                size="invisible"
                ref={reRef}
              />
            </ButtonDiv>

            <ButtonDiv style={{ marginTop: "4rem" }}>
              <VATbutton type="submit">Contact Invoitix</VATbutton>
            </ButtonDiv>
          </form>
        </FormWrapperInner>
      </FormContainer>
    </Factoring>
  );
};

export default FactoringPage;
